/* src/app/master-data/branches/branches.component.css */
/*# sourceMappingURL=branches.component-QMUEP3ZF.css.map */
